const accountNeedsConfiguration = (landlord) => {
    const needsToConfigurePassword = !landlord.has_password && !landlord.googleId && !landlord.facebookId || landlord.changedTemporaryPassword === false;
    const needsToFinishStripeConnectConfig = !landlord.stripeAccountId || !landlord.stripeIsUpdated;
    return (
        (!landlord.email_verified || needsToConfigurePassword || needsToFinishStripeConnectConfig)
        && !landlord.impersonateOriginal)
    //return window.location.href = "/start/verification";
}

export default accountNeedsConfiguration;
